<template>
  <div>
    <div class="">
      <div>
        <b-tooltip multilined type="is-light" :position="position">
          <b-tag type="is-success" class="is-small">
            <b-icon
              size="is-small"
              icon="check-circle"
              custom-class="mr-1"
            ></b-icon>
            Recommended
          </b-tag>
          <template v-slot:content>
            <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
              Recommended Flight Option
            </h5>
          </template>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NDCTag",
  props: {
    type: String,
    position: {
      type: String,
      default: "is-bottom",
    },
  },
  data() {
    return {
      // active: false,
    }
  },
  mounted() {},
  methods: {},
  computed: {},
}
</script>

<style scoped></style>
